/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ service: NonNullable<unknown> }} Directory_Title_OnlineInputs */

const en_directory_title_online = /** @type {(inputs: Directory_Title_OnlineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.service} online`)
};

const pl_directory_title_online = /** @type {(inputs: Directory_Title_OnlineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.service} online`)
};

/**
* | output |
* | --- |
* | "{service} online" |
*
* @param {Directory_Title_OnlineInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_title_online = /** @type {((inputs: Directory_Title_OnlineInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Title_OnlineInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_title_online(inputs)
	return en_directory_title_online(inputs)
});